const footerNav = [
  { label: "核心功能", href: "#features" },
  { label: "同城交友圈", href: "#cities" },
  { label: "单身群", href: "#groups" },
  { label: "聊天室", href: "#chatrooms" },
  { label: "缘分匹配", href: "#matching" },
  { label: "安全指南", href: "#safety" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-xl text-background-50">爱情岛</span>
                <span className="text-[11px] tracking-wide text-secondary-300">同城交友社区</span>
              </span>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-secondary-200">
              爱情岛汇集同城单身男女，通过婚恋匹配、单身群互动和聊天室畅聊，帮你自然遇见缘分。
              无论想扩大社交圈还是认真找对象，这里都有适合你的交友场景。
            </p>
            <div className="flex flex-wrap gap-2">
              {["同城交友", "婚恋", "单身群", "聊天室", "缘分"].map((tag) => (
                <span key={tag} className="rounded-full border border-secondary-700 px-3 py-1 text-xs text-secondary-200">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="font-heading text-base text-background-50">快速导航</h3>
            <nav className="grid grid-cols-2 gap-2 sm:grid-cols-1">
              {footerNav.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-secondary-200 transition-colors hover:text-background-50 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="font-heading text-base text-background-50">社区倡导</h3>
            <ul className="flex flex-col gap-2 text-sm text-secondary-200">
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-primary-400" aria-hidden="true"></i>
                真诚交流，不伪造身份与照片
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-emotion-normal-line mt-0.5 text-primary-400" aria-hidden="true"></i>
                尊重对方边界与节奏
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-alarm-warning-line mt-0.5 text-primary-400" aria-hidden="true"></i>
                遇到异常及时举报
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-secondary-300">© 2026 爱情岛同城交友社区 · 本站为内容展示页面</p>
          <p className="text-xs text-secondary-300">请理性交友，注意人身与财产安全</p>
        </div>
      </div>
    </footer>
  );
}